<cm-image-viewer
  [images]="this.message.images"
  [currentImage]="0"
  (backPressed)="onBackPressed($event)"
></cm-image-viewer>
